import { default as MentionExtension } from "@tiptap/extension-mention";
import { NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import { ReactNodeViewRenderer, mergeAttributes } from "@tiptap/react";

import { cx } from "@/lib/tailwind-utils";

import { punctuationAfterMention } from "./punctuation-after-mention";

export function Mention(props: NodeViewProps) {
  return (
    <NodeViewWrapper className="inline w-fit">
      <span
        className={cx(
          "rounded bg-primary/10 box-decoration-clone px-[0.3rem] py-[0.1rem] text-primary",
        )}
      >
        @{props.node.attrs.label}
      </span>
    </NodeViewWrapper>
  );
}

export const CustomMention = MentionExtension.extend({
  addNodeView() {
    return ReactNodeViewRenderer(Mention);
  },
  parseHTML() {
    return [
      {
        tag: "mention-component",
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["mention-component", mergeAttributes(HTMLAttributes)];
  },
  addProseMirrorPlugins() {
    return [...(this.parent?.() ?? []), punctuationAfterMention(this.name)];
  },
});
